export default __webpack_public_path__ + "static/media/making-art.87a1eb61.svg";